


























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import StaffPane from '@/components/staff/staff-pane.vue'
import { RequestPaging } from '@/utils/util'
import { apiStaffLists, apiWorkerTypeList } from '@/api/staff'

@Component({
  components: {
    StaffPane
  }
})
export default class StaffList extends Vue {
    queryObj: any = {
      keyword: '',
      worker_type_id: '',
      employment_type: '',
      staff_status: '',
      current_status: '',
      is_blacklist: ''
    }

    workerTypeList: any[] = []

    pager = new RequestPaging()
    apiStaffLists = apiStaffLists

    getList (page?: number): void {
      page && (this.pager.page = page)
      this.pager
        .request({
          callback: apiStaffLists,
          params: {
            ...this.queryObj
          }
        })
    }

    handleReset () {
      this.queryObj = {
        keyword: '',
        worker_type_id: '',
        employment_type: '',
        staff_status: '',
        current_status: '',
        is_blacklist: ''
      }
      this.getList(1)
    }

    handleAdd () {
      this.$router.push('/staff/add')
    }

    handleExport () {
      // 导出功能实现
      console.log('导出数据')
    }

    getWorkerTypeList () {
      apiWorkerTypeList().then((res: any) => {
        this.workerTypeList = res.lists || []
      })
    }

    created () {
      this.getWorkerTypeList()
      this.getList()
    }

    activated () {
      this.getList()
    }
}
